import { styled } from "@mui/material";
import SentimentNeutralIcon from "@mui/icons-material/SentimentNeutral";
import SentimentSatisfiedAltOutlinedIcon from "@mui/icons-material/SentimentSatisfiedAltOutlined";
import SentimentDissatisfiedOutlinedIcon from "@mui/icons-material/SentimentDissatisfiedOutlined";
import ThunderstormOutlinedIcon from "@mui/icons-material/ThunderstormOutlined";
import ThumbUpOffAltIcon from "@mui/icons-material/ThumbUpOffAlt";
import BedtimeOutlinedIcon from "@mui/icons-material/BedtimeOutlined";
import QuestionMarkOutlinedIcon from "@mui/icons-material/QuestionMarkOutlined";
import EmojiObjectsOutlinedIcon from "@mui/icons-material/EmojiObjectsOutlined";
import CampaignOutlinedIcon from "@mui/icons-material/CampaignOutlined";
import CelebrationOutlinedIcon from "@mui/icons-material/CelebrationOutlined";
import SentimentVerySatisfiedOutlinedIcon from "@mui/icons-material/SentimentVerySatisfiedOutlined";
import HearingOutlinedIcon from "@mui/icons-material/HearingOutlined";
import NewspaperOutlinedIcon from "@mui/icons-material/NewspaperOutlined";
import RecordVoiceOverOutlinedIcon from "@mui/icons-material/RecordVoiceOverOutlined";
import HeadsetMicOutlinedIcon from "@mui/icons-material/HeadsetMicOutlined";
import MenuBookOutlinedIcon from "@mui/icons-material/MenuBookOutlined";
import SupportAgentOutlinedIcon from "@mui/icons-material/SupportAgentOutlined";
import BusinessCenterOutlinedIcon from "@mui/icons-material/BusinessCenterOutlined";
import RadioButtonUncheckedIcon from "@mui/icons-material/RadioButtonUnchecked";

export interface EmotionProps {
  icon: React.ComponentType;
  name: string;
}

// Default icon for unknown styles
export const FadedDefaultIcon = styled(RadioButtonUncheckedIcon)({
  opacity: 0.6,
});

// Icon mapping for known styles
export const styleIconMapping: Record<string, React.ComponentType> = {
  neutral: SentimentNeutralIcon,
  happy: SentimentSatisfiedAltOutlinedIcon,
  sad: SentimentDissatisfiedOutlinedIcon,
  question: QuestionMarkOutlinedIcon,
  angry: ThunderstormOutlinedIcon,
  helpful: EmojiObjectsOutlinedIcon,
  amused: SentimentVerySatisfiedOutlinedIcon,
  surprised: CelebrationOutlinedIcon,
  positive: ThumbUpOffAltIcon,
  soothing: BedtimeOutlinedIcon,
  whispering: HearingOutlinedIcon,
  announcements: CampaignOutlinedIcon,
  advertising: CampaignOutlinedIcon,
  commercials: BusinessCenterOutlinedIcon,
  news: NewspaperOutlinedIcon,
  service: SupportAgentOutlinedIcon,
  storytelling: MenuBookOutlinedIcon,
  "voice assistant": HeadsetMicOutlinedIcon,
  "voice over": RecordVoiceOverOutlinedIcon,
};

export function getIconForStyle(styleName: string): React.ComponentType {
  const normalizedName = styleName.toLowerCase().trim();
  return styleIconMapping[normalizedName] || FadedDefaultIcon;
}
